export class ImageModel {
  Name: string;
  ImagePath: string;

  constructor(name: string, imagePath: string) {
    this.Name = name;
    this.ImagePath = imagePath;
  }
}
